var product_id_to_reopen = null;

async function fetchUpsellMetafield(productId) {
  const SHOPIFY_DOMAIN = "h0qhur-dr.myshopify.com";
  const STOREFRONT_TOKEN = "87694ea046e307eac0135c30b405044b";

  const query = `
    query GetUpsellMetafield($id: ID!) {
      product(id: $id) {
        id
        handle
        title
        metafield(namespace: "custom", key: "upsell_products") {
          type
          value
        }
      }
    }
  `;

  const res = await fetch("https://" + SHOPIFY_DOMAIN + "/api/2025-01/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN
    },
    body: JSON.stringify({
      query: query,
      variables: { id: "gid://shopify/Product/" + productId }
    })
  });

  const json = await res.json();
  const metafield = json && json.data && json.data.product && json.data.product.metafield;

  if (!metafield || !metafield.value) return [];

  var list = [];
  try {
    list = JSON.parse(metafield.value);
  } catch (e) {
    return [];
  }

  return list;
}

async function loadAllUpsellProducts(gids) {
  var ids = gids.map(function(id) {
    return String(id).replace("gid://shopify/Product/", "");
  });

  var res = await fetch("/products.json?limit=250");
  var json = await res.json();
  var products = json && json.products ? json.products : [];

  var filtered = products.filter(function(p) {
    return ids.includes(String(p.id));
  });

  filtered.sort(function(a, b) {
  return ids.indexOf(String(a.id)) - ids.indexOf(String(b.id));
});

  // Fetch all custom titles in parallel instead of sequentially
  await Promise.all(filtered.map(async function(p) {
    var gid = "gid://shopify/Product/" + p.id;

    try {
      var gql = `
        query GetCustomTitle($id: ID!) {
          product(id: $id) {
            metafield(namespace: "custom", key: "custom_title_product") {
              value
            }
          }
        }
      `;

      var resp = await fetch("https://h0qhur-dr.myshopify.com/api/2025-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "87694ea046e307eac0135c30b405044b"
        },
        body: JSON.stringify({
          query: gql,
          variables: { id: gid }
        })
      });

      var data = await resp.json();

      p.custom_title_product =
        data &&
        data.data &&
        data.data.product &&
        data.data.product.metafield &&
        data.data.product.metafield.value
          ? data.data.product.metafield.value
          : null;

    } catch (e) {
      p.custom_title_product = null;
    }
  }));

  return filtered;
}

const upsellModalHTML = '\
<div id="upsell-modal" class="upsell-modal">\
  <div class="upsell-backdrop"></div>\
  <div class="upsell-content">\
    <button class="upsell-close-button"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg></button>\
    <div id="upsell-body">Loading...</div>\
  </div>\
</div>\
\
<style>\
.upsell-modal { position: fixed; inset: 0; z-index: 2 !important; display: none; }\
.upsell-modal.active { display: block !important; }\
.upsell-backdrop { position: fixed !important; inset: 0 !important; background: rgba(0,0,0,0.6) !important; pointer-events: all !important; z-index: 2001 !important; opacity: 1 !important; display: block !important; }\
.upsell-content { position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; background: #131313; padding: 28px 20px 24px 20px; width: 760px; max-width: 90%; border-radius: 14px; box-shadow: 0 16px 40px rgba(0,0,0,0.45); z-index: 2002 !important; color: #ffffff; box-sizing: border-box; }\
.upsell-close-button { position: absolute; top: 16px; right: 20px; background: none; border: none; font-size: 28px; cursor: pointer; color: #ffffff; }\
.upsell-title { text-align: center; font-size: 22px; font-weight: 600; margin: 0 0 4px 0; }\
.upsell-subtitle { text-align: center; opacity: 0.7; margin-bottom: 18px; font-size: 13px; }\
.upsell-add-btn { background: #DD2A30; color: #ffffff; padding: 10px 0; border-radius: 30px; width: 100%; font-size: 14px; cursor: pointer; transition: 0.15s; border: none; font-weight: 600; }\
.upsell-add-btn:hover { opacity: 0.9; }\
.upsell-carousel { position: relative; display: flex; align-items: center; justify-content: center; }\
.upsell-carousel-track-wrapper { overflow: hidden; width: 100%; max-width: 760px; margin: 0 auto; }\
.upsell-carousel-track { display: flex; transition: transform 0.3s ease; will-change: transform; }\
.upsell-slide { flex: 0 0 33.3333%; max-width: 33.3333%; padding: 0 12px 4px 12px; box-sizing: border-box; text-align: center; }\
.upsell-product-link { color: inherit; text-decoration: none; position: relative; z-index: 1; pointer-events: auto; }\
.upsell-product-link:hover { color: inherit; text-decoration: none; }\
.upsell-product-link--image { display: block; }\
.upsell-image-wrap { width: 100%; max-width: 260px; margin: 0 auto 10px auto; }\
.upsell-image-wrap img { width: 100%; max-height: 260px; border-radius: 10px; display: block; object-fit: contain; }\
.upsell-title-small { font-size: 15px; font-weight: 600; margin: 4px 0 2px 0; min-height: 40px; display: flex; align-items: center; justify-content: center; padding: 0 4px; }\
.upsell-price { font-size: 14px; opacity: 0.8; margin-bottom: 6px; min-height: 20px; display: flex; align-items: center; justify-content: center; }\
.upsell-options { margin-top: 4px; margin-bottom: 8px; display: flex; flex-direction: column; gap: 6px; align-items: center; }\
.upsell-option-select { padding: 4px 6px; border-radius: 6px; border: 1px solid #DD2A30; background: #161617; color: #FFFFFF; font-size: 13px; max-width: 100%; }\
.upsell-arrow { background: none; border: none; font-size: 26px; cursor: pointer; color: #ffffff; padding: 6px 8px; }\
.upsell-arrow.disabled { opacity: 0.2; cursor: default; }\
.upsell-dots { display: flex; justify-content: center; margin-top: 12px; gap: 7px; }\
.upsell-dot { width: 7px; height: 7px; border-radius: 50%; background: #666666; cursor: pointer; }\
.upsell-dot.active { background: #ffffff; }\
@media (max-width: 600px) { .upsell-content { width: 100%; max-width: 100%; border-radius: 0; transform: translate(-50%, -50%); } .upsell-carousel-track-wrapper { max-width: 100%; } .upsell-slide { flex: 0 0 100%; max-width: 100%; } }\
</style>';

document.addEventListener("DOMContentLoaded", function() {
  document.body.insertAdjacentHTML("beforeend", upsellModalHTML);
});

var upsellModal;
var upsellBody;
var upsellClose;
var upsellBackdrop;

document.addEventListener("DOMContentLoaded", function() {
  upsellModal = document.getElementById("upsell-modal");
  upsellBody = document.getElementById("upsell-body");
  upsellClose = document.querySelector(".upsell-close-button");
  upsellBackdrop = document.querySelector(".upsell-backdrop");

  if (upsellClose) upsellClose.onclick = closeUpsellModal;

  if (upsellBackdrop) {
    upsellBackdrop.addEventListener("click", closeUpsellModal);
  }
});

if (typeof window.__upsellModalOpen === "undefined") {
  window.__upsellModalOpen = false;
}

function openUpsellModal(product, upsellProducts) {
  if (window.__upsellModalOpen) return;
  if (!upsellProducts || !upsellProducts.length) return;
  window.__upsellModalOpen = true;
  loadUpsellData(product, upsellProducts);
  if (upsellModal) upsellModal.classList.add("active");
}

function closeUpsellModal() {
  if (upsellModal) upsellModal.classList.remove("active");
  window.__upsellModalOpen = false;
}

async function addUpsellToCart(variantId) {
  if (!variantId) return;

  const productsWithMetaAll = window.productsWithMetaAll || [];

  const variant = productsWithMetaAll
    .flatMap(p => p.variants)
    .find(v => String(v.id) === String(variantId));

  let autoAddProductId = null;

  if (variant && variant.metafields["custom.auto_add_product"]) {
    autoAddProductId = variant.metafields["custom.auto_add_product"]
      .replace("gid://shopify/Product/", "");
  }

  // Step 1: Get auto-add variant ID first (if needed)
  let autoAddVariantId = null;
  if (autoAddProductId) {
    const linkedProduct = productsWithMetaAll.find(p => p.id === autoAddProductId);
    if (linkedProduct) {
      try {
        const resProduct = await fetch(`/products/${linkedProduct.handle}.js`);
        const jsonProd = await resProduct.json();
        autoAddVariantId = jsonProd.variants?.[0]?.id;
      } catch (err) {
        console.error('[Joyrider] Error fetching auto-add product:', err);
      }
    }
  }

  // Step 2: Add all items to cart in parallel
  const itemsToAdd = [
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
  ];

  if (autoAddVariantId) {
    itemsToAdd.push(
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: autoAddVariantId, quantity: 1 })
      })
    );
  }

  // Wait for all items to be added
  await Promise.all(itemsToAdd);

  try {
    const slide = document.querySelector(`.upsell-slide[data-id="${variantId}"]`);
    if (slide) slide.remove();

    const remaining = document.querySelectorAll(".upsell-slide");

    if (remaining.length === 0) {
      closeUpsellModal();
    }
  } catch (e) {}

  // Refresh the cart drawer properly
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    try {
      // Fetch updated cart drawer section
      const res = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`);
      
      if (res.ok) {
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        
        // Update cart drawer content
        const drawerInner = document.querySelector('#CartDrawer');
        const sourceDrawer = html.querySelector('#CartDrawer');
        if (drawerInner && sourceDrawer) {
          drawerInner.innerHTML = sourceDrawer.innerHTML;
        }
        
        // Update cart icon bubble
        const cartIconBubble = document.querySelector('#cart-icon-bubble');
        const sourceIcon = html.querySelector('#cart-icon-bubble');
        if (cartIconBubble && sourceIcon) {
          cartIconBubble.innerHTML = sourceIcon.innerHTML;
        }
        
        // Open the cart drawer
        cartDrawer.open();
      }
    } catch (err) {
      console.error('[Joyrider] Error refreshing cart:', err);
    }
  }
  
  // Also publish cart update event for other listeners
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'upsell-modal',
      productVariantId: variantId
    });
  }
}

function loadUpsellData(product, upsellProducts) {
  if (!upsellBody) return;

  if (!upsellProducts || !upsellProducts.length) {
    upsellBody.innerHTML =
      '<div class="upsell-title">{{ settings.upsell_modal_title }}</div>' +
      '<div class="upsell-subtitle">{{ settings.upsell_modal_subtitle }}</div>'
    return;
  }

  var slidesHtml = upsellProducts.map(function(p) {
    var image = p.images && p.images[0] && p.images[0].src ? p.images[0].src : "";
    var firstVariant = p.variants && p.variants[0] ? p.variants[0] : null;
    var variantId = firstVariant ? firstVariant.id : p.id;
    var price = firstVariant && firstVariant.price ? firstVariant.price : "";
    var productJson = JSON.stringify(p).replace(/'/g, "&apos;");

    var selectors = "";
    if (p.options && p.options.length > 0) {
      p.options.forEach(function(opt, idx) {
        var values = Array.from(new Set(
          (p.variants || []).map(function(v) { return v["option" + (idx + 1)]; })
        )).filter(function(v) { return v && v !== "Default Title"; });

        if (values.length <= 1) return;

        var optionsHtml = values.map(function(v) {
          return '<option value="' + v + '">' + v + '</option>';
        }).join("");

        selectors += '<select class="upsell-option-select" data-index="' + (idx + 1) + '">' + optionsHtml + '</select>';
      });
    }

    var optionsBlock = selectors ? '<div class="upsell-options">' + selectors + '</div>' : '';
    var displayTitle =
  p.custom_title_product &&
  typeof p.custom_title_product === "string" &&
  p.custom_title_product.trim() !== ""
    ? p.custom_title_product.trim()
    : p.title;
    var productUrl = p.handle ? '/products/' + p.handle : '#';
    var safeTitle = String(displayTitle || '').replace(/"/g, '&quot;');

    return '\
  <div class="upsell-slide" data-id="' + variantId + '" data-product=\'' + productJson + '\'>\
    <a class="upsell-product-link upsell-product-link--image" href="' + productUrl + '">\
      <div class="upsell-image-wrap"><img src="' + image + '" alt="' + safeTitle + '"></div>\
    </a>\
    <a class="upsell-product-link" href="' + productUrl + '">\
      <div class="upsell-title-small">' + displayTitle + '</div>\
    </a>\
    <div class="upsell-price">' + (price ? "$" + price : "") + '</div>\
    ' + optionsBlock + '\
    <product-form class="product-form upsell-product-form" data-hide-errors="false">\
      <form method="post" action="/cart/add" class="form" novalidate="novalidate" data-type="add-to-cart-form">\
        <input type="hidden" name="id" value="' + variantId + '">\
        <button type="submit" name="add" class="upsell-add-btn">\
          <span>Add to cart</span>\
          <div class="loading__spinner hidden">\
            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">\
              <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>\
            </svg>\
          </div>\
        </button>\
      </form>\
    </product-form>\
  </div>';

  }).join("");

  var cfg = document.getElementById("upsell-config");
var modalTitle = cfg?.dataset?.title || "ADD TO YOUR KIT";
var modalSubtitle = cfg?.dataset?.subtitle || "WITH THESE COMPATIBLE ITEMS";

var html =
  '<div class="upsell-title">' + modalTitle + '</div>' +
  '<div class="upsell-subtitle">' + modalSubtitle + '</div>' +
  '<div class="upsell-carousel">' +
    '<button class="upsell-arrow upsell-prev"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></button>' +
    '<div class="upsell-carousel-track-wrapper">' +
      '<div class="upsell-carousel-track">' + slidesHtml + '</div>' +
    '</div>' +
    '<button class="upsell-arrow upsell-next"><svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg></button>' +
  '</div>' +
  '<div class="upsell-dots"></div>';


  upsellBody.innerHTML = html;

  var track = upsellBody.querySelector(".upsell-carousel-track");
  var wrapper = upsellBody.querySelector(".upsell-carousel-track-wrapper");
  var nextBtn = upsellBody.querySelector(".upsell-next");
  var prevBtn = upsellBody.querySelector(".upsell-prev");
  var dotsContainer = upsellBody.querySelector(".upsell-dots");

  if (!track || !wrapper || !nextBtn || !prevBtn || !dotsContainer) return;

  var slides = Array.prototype.slice.call(track.children);
  var slidesCount = slides.length;
  if (!slidesCount) return;

  var i;
  for (i = 0; i < slidesCount; i++) {
    dotsContainer.insertAdjacentHTML("beforeend", '<div class="upsell-dot" data-i="' + i + '"></div>');
  }
  var dots = Array.prototype.slice.call(dotsContainer.children);

  var currentIndex = 0;

  function getSlideMetrics() {
  var slide = slides[0];
  var slideWidth = slide.offsetWidth;

  var gap = 0;
  if (slides.length > 1) {
    var left0 = slides[0].offsetLeft;
    var left1 = slides[1].offsetLeft;
    gap = left1 - left0 - slideWidth;
    if (gap < 0) gap = 0;
  }

  var wrapperWidth = wrapper.offsetWidth || 1;

  var visible = Math.floor((wrapperWidth + gap) / (slideWidth + gap));

  if (window.innerWidth >= 600) {
    visible = 3;
  } else {
    visible = 1;
  }

  return { slideWidth: slideWidth, gap: gap, wrapperWidth: wrapperWidth, visible: visible };
}


  function updateDots() {
    dots.forEach(function(dot) { dot.classList.remove("active"); });
    if (dots[currentIndex]) dots[currentIndex].classList.add("active");
  }

  function updateArrows() {
    var m = getSlideMetrics();
    var lastIndex = Math.max(0, slidesCount - m.visible);

    prevBtn.classList.remove("disabled");
    nextBtn.classList.remove("disabled");

    if (currentIndex <= 0) prevBtn.classList.add("disabled");
    if (currentIndex >= lastIndex) nextBtn.classList.add("disabled");

    if (slidesCount <= m.visible) {
      prevBtn.style.display = "none";
      nextBtn.style.display = "none";
      dotsContainer.style.display = "none";
    } else {
      prevBtn.style.display = "";
      nextBtn.style.display = "";
      dotsContainer.style.display = "";
    }
  }

  function updatePosition() {
    var m = getSlideMetrics();
    var lastIndex = Math.max(0, slidesCount - m.visible);

    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex > lastIndex) currentIndex = lastIndex;

    var left = currentIndex * (m.slideWidth + m.gap);

    track.style.transform = "translateX(" + (-left) + "px)";

    updateDots();
    updateArrows();
  }

  updatePosition();

  nextBtn.onclick = function() {
    var m = getSlideMetrics();
    var lastIndex = Math.max(0, slidesCount - m.visible);
    if (currentIndex >= lastIndex) return;
    currentIndex += 1;
    updatePosition();
  };

  prevBtn.onclick = function() {
    if (currentIndex <= 0) return;
    currentIndex -= 1;
    updatePosition();
  };

  dots.forEach(function(dot) {
    dot.onclick = function() {
      var idx = Number(dot.getAttribute("data-i"));
      if (!isNaN(idx)) {
        currentIndex = idx;
        updatePosition();
      }
    };
  });

  var touchStartX = 0;
  var touchEndX = 0;

  wrapper.addEventListener("touchstart", function(e) {
    if (!e.touches || !e.touches.length) return;
    touchStartX = e.touches[0].clientX;
  });

  wrapper.addEventListener("touchend", function(e) {
    if (!e.changedTouches || !e.changedTouches.length) return;
    touchEndX = e.changedTouches[0].clientX;
    var diff = touchEndX - touchStartX;
    if (Math.abs(diff) < 40) return;

    var m = getSlideMetrics();
    var lastIndex = Math.max(0, slidesCount - m.visible);

    if (diff < 0 && currentIndex < lastIndex) {
      currentIndex += 1;
      updatePosition();
    } else if (diff > 0 && currentIndex > 0) {
      currentIndex -= 1;
      updatePosition();
    }
  });

  window.addEventListener("resize", updatePosition);

  slides.forEach(function(slide) {
    var productStr = slide.getAttribute("data-product");
    if (!productStr) return;

    var product;
    try {
      product = JSON.parse(productStr.replace(/&apos;/g, "'"));
    } catch (e) {
      return;
    }

    var priceRail = slide.querySelector(".upsell-price");
    var selectEls = slide.querySelectorAll(".upsell-option-select");

    function recalcPriceAndMeta(variantId) {
      if (!variantId) return;

      var productsWithMetaAll = window.productsWithMetaAll || [];
      var metaVariant = null;

      if (productsWithMetaAll && productsWithMetaAll.length) {
        var flat = [];
        productsWithMetaAll.forEach(function(p) {
          var vs = p.variants || [];
          vs.forEach(function(v) {
            flat.push(v);
          });
        });

        metaVariant = flat.find(function(v) {
          return String(v.id) === String(variantId);
        });
      }

      if (!metaVariant) {
        var foundVariant = (product.variants || []).find(function(v) {
          return String(v.id) === String(variantId);
        });
        if (foundVariant && foundVariant.price && priceRail) {
          priceRail.textContent = "$" + foundVariant.price;
        }
        return;
      }

      var totalPrice = parseFloat(metaVariant.price || 0);
      var autoAddProductGid = metaVariant.metafields && metaVariant.metafields["custom.auto_add_product"];

      if (autoAddProductGid) {
        var autoAddProductId = autoAddProductGid.replace("gid://shopify/Product/", "");
        var autoAdd = (window.productsWithMetaAll || []).find(function(p) {
          return String(p.id) === String(autoAddProductId);
        });

        if (autoAdd && autoAdd.variants && autoAdd.variants.length) {
          var autoAddPrice = parseFloat(autoAdd.variants[0].price || 0);
          totalPrice += autoAddPrice;
        }
      }

      var currency = metaVariant.currency || "USD";
      var formatted;
      try {
        formatted = totalPrice.toLocaleString("en-US", {
          style: "currency",
          currency: currency,
          minimumFractionDigits: 2
        });
      } catch (e) {
        formatted = "$" + totalPrice.toFixed(2);
      }

      if (priceRail) priceRail.textContent = formatted;
    }

    function updateVariantFromSelects() {
      if (!selectEls.length) return;

      var selected = Array.prototype.slice.call(selectEls).map(function(s) {
        return s.value.trim();
      });

      var match = (product.variants || []).find(function(v) {
        return selected.every(function(val, idx) {
          var key = "option" + (idx + 1);
          return String(v[key]).trim() === val;
        });
      });

      if (match) {
        var variantId = match.id;
        slide.setAttribute("data-id", variantId);
        recalcPriceAndMeta(variantId);
      }
    }

    if (selectEls.length) {
      Array.prototype.forEach.call(selectEls, function(select) {
        select.addEventListener("change", updateVariantFromSelects);
      });
      updateVariantFromSelects();
    } else {
      var initialId = slide.getAttribute("data-id");
      if (initialId) recalcPriceAndMeta(initialId);
    }
  });

  var buttons = upsellBody.querySelectorAll(".upsell-add-btn");
  buttons.forEach(function(btn) {
    btn.onclick = function() {
      var slide = btn.closest(".upsell-slide");
      if (!slide) return;
      var id = slide.getAttribute("data-id");
      addUpsellToCart(id);
    };
  });
}

document.addEventListener("click", async function(e) {

  const cfg = document.getElementById("upsell-config");
  var enableModal = cfg?.dataset?.enable === "true";
  if (!enableModal) return;

  const btn = e.target.closest(".product-form__submit");
  if (!btn) return;

  const form = btn.closest("form");
  if (!form) return;

  const variantId = form.querySelector("input[name='id']")?.value;

  let productId =
    form.querySelector("input[name='product-id']")?.value ||
    form.querySelector("input[name='product']")?.value ||
    form.dataset.productId ||
    form.getAttribute("data-product-id") ||
    null;

  if (!productId) return;

  if (productId === product_id_to_reopen) {
    return;
  }

  const fullData = await fetchUpsellMetafield(productId);

  const upsellProducts = await loadAllUpsellProducts(fullData);
  if (upsellProducts.length > 0) {
    openUpsellModal(
      { id: productId, variant_id: variantId },
      upsellProducts
    );
  }

  product_id_to_reopen = productId;
});






